import { Controller } from "stimulus"

// Generic Web Share API button — falls back to copying a share message to the clipboard on
// browsers/devices without navigator.share (most desktop browsers).
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String
  }

  async share() {
    const shareData = {
      title: this.titleValue,
      text: this.textValue,
      url: this.urlValue
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch {
        // User cancelled the share sheet — no action needed.
      }
      return
    }

    await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`)
    const original = this.element.textContent
    this.element.textContent = "Link copied!"
    setTimeout(() => { this.element.textContent = original }, 2000)
  }
}
